import { useState } from "react";
import type { ReactNode } from "react";

export interface TabItem {
  id: string;
  label: string;
  content: ReactNode;
}

export interface TabsProps {
  items: TabItem[];
  defaultTab?: string;
  /** modo controlado (opcional) */
  value?: string;
  onChange?: (id: string) => void;
}

export default function Tabs({ items, defaultTab, value, onChange }: TabsProps) {
  const [internal, setInternal] = useState(defaultTab ?? items[0]?.id);
  const active = value ?? internal;

  function select(id: string) {
    setInternal(id);
    onChange?.(id);
  }

  return (
    <div>
      <div role="tablist" className="flex gap-1 border-b border-line/60">
        {items.map((item) => {
          const isActive = item.id === active;
          return (
            <button
              key={item.id}
              role="tab"
              aria-selected={isActive}
              onClick={() => select(item.id)}
              className={`-mb-px border-b-2 px-3 py-2 text-sm transition-colors ${
                isActive
                  ? "border-brand text-ink"
                  : "border-transparent text-ink-muted hover:text-ink"
              }`}
            >
              {item.label}
            </button>
          );
        })}
      </div>
      <div role="tabpanel" className="pt-5">
        {items.find((item) => item.id === active)?.content}
      </div>
    </div>
  );
}
